<template>
  <div>
    <template v-if="viewType === 'decorationDetail'">
      <check-detail @cancel="cancel" :id="currentId" type="see" :showHistory="false"></check-detail>
    </template>
    <template v-else-if="viewType === 'approvalDetail'">
      <employment-detail  @changeType="cancel"
                          :initId="currentId" :showHistory="false"></employment-detail>
    </template>

    <template v-else-if="viewType === 'flowDetail'">
      <entry-flow-detail @changeType="cancel" :id="currentId"  :showHistory="false"></entry-flow-detail>
    </template>

    <template v-else-if="viewType === 'contractDetail'">
      <labor-contract-detail @changeType="cancel" :id="currentId"  :showHistory="false"></labor-contract-detail>
    </template>

    <template v-else-if="viewType === 'positiveDetail'">
      <positive-detail @changeType="cancel" :id="currentId"  :showHistory="false"></positive-detail>
    </template>

    <template
        v-else-if="['dynamicFormDetail'].includes(viewType)"
    >
      <dynamic-form-wrapper
          :id="currentId"
          :viewType="viewType"
          :showHistory="false"
          @changeType="cancel"
      ></dynamic-form-wrapper>
    </template>
  </div>
</template>

<script>
import CheckDetail from "@/pages/businessModule/examine/formDetail/checkDetail";
import LaborContractDetail from "@/pages/businessModule/personnel/labor-contract/detail";
import PositiveDetail from "@/pages/businessModule/personnel/positive/detail";
import DynamicFormWrapper from "@/pages/checkModule/examine/components/dynamicFormWrapper";
import EmploymentDetail from "@/pages/businessModule/personnel/employmentApplication/detail";
import EntryFlowDetail from "@/pages/businessModule/personnel/entryFlow/detail";
export default {
  name: "approval-statistics-detail",
  components: {
    EntryFlowDetail,
    EmploymentDetail,
    DynamicFormWrapper,
    PositiveDetail,
    LaborContractDetail,
    CheckDetail
  },
  data(){
    return {
      typeId:0,
      currentId:0,
      viewType:''
    }
  },
  mounted(){
    this.typeId = this.$route.params.typeId;
    this.currentId = this.$route.params.id;
    this.showDetail()
  },
  methods:{
    showDetail() {
      switch (+this.typeId) {
        case 5:
          this.viewType = 'approvalDetail';  // 入职申请
          break;
        case 6:
          this.viewType = 'flowDetail';  // 入职流转
          break;
        case 7:
          this.viewType = 'contractDetail';  // 劳动合同
          break;
        case 8:
          this.viewType = 'positiveDetail';  // 转正申请
          break;
        case 9:
          this.viewType = 'dynamicFormDetail';  // 动态表单
          break;
        default:
          this.viewType = 'decorationDetail';  // 装修申请
          break;
      }
    },
    cancel(){
      this.$router.go(-1)
    }
}
}
</script>

<style scoped>

</style>